import { Component } from '@angular/core';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { getHrefBasePath } from '../../utilities/url-utilities';

@Component({
    selector: 'pace-core-pace-partner-zgid-error-modal',
    templateUrl: './pace-partner-zgid-error-modal.component.html',
    styleUrls: ['./pace-partner-zgid-error-modal.component.scss'],
})
export class PacePartnerZgidErrorModalComponent {
    public faExternalLink = faExternalLinkAlt;
    public paceTarget: string | undefined;

    public constructor() {
        const currentHref = getHrefBasePath(window.location.href);
        if (currentHref.includes('-partners.azurewebsites.net')) {
            this.paceTarget = currentHref.replace('-partners.azurewebsites.net', '.azurewebsites.net');
        }
        if (currentHref.includes('-for-partners-pwa.azurewebsites.net')) {
            this.paceTarget = currentHref.replace('-for-partners-pwa.azurewebsites.net', '-pwa.azurewebsites.net');
        }
        if (currentHref.includes('-partners.siemens-healthineers.com')) {
            this.paceTarget = currentHref.replace(
                '-partners.siemens-healthineers.com',
                '-pwa.siemens-healthineers.com',
            );
        }
        if (currentHref.includes('-for-partners-pwa.siemens-healthineers.com')) {
            this.paceTarget = currentHref.replace(
                '-for-partners-pwa.siemens-healthineers.com',
                '-pwa.siemens-healthineers.com',
            );
        }
    }

    public openInternalPace(): void {
        if (this.paceTarget !== undefined) {
            window.location.href = this.paceTarget;
        }
    }
}
